<template>
  <DsDialog
    v-model="localVisible"
    :before-close="() => this.onClose(false)"
    :show-close="false"
    :close-on-click-modal="false"
    custom-class="agregarDetalleDialog"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    width="55%"
    max-width="55%"
    height="72vh"
    max-height="72vh"
    header-bg-color="var(--main-color)"
  >

      <!-- Header -->
    <template #header>
        <el-row class="headerDialog" style="background-color: var(--main-color);">
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">{{$t('PRESUPUESTO_detalle')}}</el-col>
        </el-row>
    </template>

    <!-- Body -->
    <div> 
        <el-row>
            <div class="label">{{$t('PRESUPUESTO_detalle_IVA_label')}}</div>
            <el-radio-group v-model="iva_detalle" class="radioGroup">
                <el-radio :label="codigosIVA.iva25">{{$t('PRESUPUESTO_detalle_IVA_21')}}</el-radio>
                <el-radio :label="codigosIVA.iva10">{{$t('PRESUPUESTO_detalle_IVA_10')}}</el-radio>
                <el-radio :label="codigosIVA.iva0">{{$t('PRESUPUESTO_detalle_IVA_0')}}</el-radio>
            </el-radio-group>
        </el-row>

        <el-row :gutter="20" class="rowDescripcion">
            <el-col :span="24">
            <div class="label">{{$t('GENERAL_descripcion')}}</div>
            <el-input
                :placeholder="$t('PRESUPUESTO_detalle_descripcion_placeholder')"
                type="textarea"
                :rows="2"
                v-model="descripcion_detalle"
            />
            </el-col>
        </el-row>

        <el-row :gutter="20" class="rowDescripcion">
            <el-col :span="24">
            <div class="label">{{$t('PRESUPUESTO_detalle_nota_tecnica')}}</div>
            <el-input
                :placeholder="$t('PRESUPUESTO_detalle_nota_tecnica_placeholder')"
                type="textarea"
                :rows="2"
                v-model="nota_tecnica_detalle"
            />
            </el-col>
        </el-row>

        <el-row :gutter="20" class="rowPrecioCantidad">
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <el-row>
                    <div class="label">{{$t('PRODUCTO_precio_unitario')}}</div>
                    <el-input type="number" :placeholder="$t('PRESUPUESTO_detalle_precio_placeholder')" v-model="precio_unitario_detalle"></el-input>
                </el-row>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" >
                <div class="label">{{$t('PRESUPUESTO_detalle_label_cantidad')}}</div>
                <div class="colCantidad">
                    <InputNumber
                    class="selectCantidadProducto"
                    :AdmiteDecimales="admiteDecimales"
                    :Minimo="'1'"
                    :Disabled="false"
                    v-model="Cantidad" />
                </div>  
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <div class="subtotalContainer">
                <div class="label">Subtotal</div>
                <div class="subtotalValue">{{subtotalLocal}}</div>
              </div>
                
            </el-col>
        </el-row>
    </div>

    <!-- Footer -->
    <template #footer>
      <span class="dialog-footer">
        <el-row class="footerActionsRow">
          <el-col :span="24" class="footerActions">
            <el-button type="primary" @click="aceptar">{{ confirmBtn || $t('GENERAL_acceptBtn') }}</el-button>
            <el-button @click="cancelar">{{ cancelBtn || $t('GENERAL_cancelBtn') }}</el-button>
          </el-col>
        </el-row>
      </span>
    </template>

  </DsDialog>
</template>

<script>
import InputNumber from "../InputNumber/InputNumber";
import DsDialog from "./DsDialog";
import { showError } from "../Mensaje";
import { decimalToString } from "../Helpers/commonFunctions";

const codigosIVA = {
  iva25: 'S06.00037-7',
  iva10: 'S06.00038-0',
  iva0: 'S06.00039-6',
};

export default {
  name: "AgregarDetalleDialog",
  components: {InputNumber, DsDialog},
  props: {
    visible: Boolean,
    cancelBtn: String,
    confirmBtn: String,
    onClose: Function,
    subtotal: Number
  },

  data() {
    return {
      localVisible: this.visible,
      limpiarDatosProductos: false,
      detalleIngresadoTemporal: [],
      productoAgregado: false,
      agregar_producto_msg: "",
      estado_msg: "",
      producto: undefined,
      innerVisible: false,
      detalleProducto: undefined,
      guardado: false,
      loading: false,
      bool_precio_unitario: false,
      bool_cantidad: false,
      admiteDecimales: 'N',
      descripcion_detalle: "",
      nota_tecnica_detalle: "",
      codigosIVA: codigosIVA,
      iva_detalle: codigosIVA.iva25,
      precio_unitario_detalle: '',
      Cantidad: 0.0,
      subtotalLocal: this.subtotal || 0,

      playZoomAnimation: false
    };
  },

  methods: {
    decimalToString: decimalToString,

    cancelar() {
      this.limpiarDatosProductos = true;
      //limpio los inputs antes de cerrar el dialog
      this.descripcion_detalle = "";
      this.nota_tecnica_detalle = "";
      this.precio_unitario_detalle="";
      this.Cantidad="0";
      this.productosSeleccionadosTemporal = [];
      this.onClose(false);
    },

    calcularImporte(precio_unitario_detalle, Cantidad) {
      this.subtotalLocal = precio_unitario_detalle * Cantidad;
    },

     mostrarSubtotal (value) {
       return (isNaN(value) || value==undefined || value==0) ? decimalToString(0) : decimalToString(value);
     },

    aceptar() {
      this.loading = true;
      // validaciones
      let valida = true;

      if (!this.descripcion_detalle) {
        showError(this.$t("PRESUPUESTO_descripcion_error"));
        valida = false;
      }
      
      if (!this.precio_unitario_detalle) {
        showError(this.$t("PRESUPUESTO_precio_unitario_error"));
        valida = false;
      }

     if (this.Cantidad =="0.0" || this.Cantidad=="0") {
        showError(this.$t("PRESUPUESTO_cantidad_error"));
        valida = false;
      }

      if (!valida) {
        this.loading = false;
        return;
      }

      //valor real del IVA
      let iva;
      if (this.iva_detalle =='S06.00037-7') {
        iva = 21;
      }
      else if (this.iva_detalle =='S06.00038-0') {
        iva = 10.5;
      }
      else {
        iva = 0;
      }

      this.detalleIngresadoTemporal = {
        Clave: this.iva_detalle,
        IVA: iva,
        Descripcion: this.descripcion_detalle,
        NotaTecnica: this.nota_tecnica_detalle,
        Precio: this.precio_unitario_detalle,
        Cantidad: this.Cantidad,
        BonificacionPorcentaje: 0,
        subtotal: this.subtotalLocal,
      }
      
      this.$emit(
        "agregarDetalleIngresado",
        this.detalleIngresadoTemporal
      );

      //limpio los inputs antes de cerrar el dialog
      this.descripcion_detalle = "";
      this.nota_tecnica_detalle = "";
      this.precio_unitario_detalle="";
      this.Cantidad="0";

      this.onClose(false);
      this.detalleIngresadoTemporal = [];
    },
   },

    watch: {
      visible(newVal) {
        this.localVisible = newVal;
      },

      precio_unitario_detalle: function () {
        this.bool_cantidad = true;
        
        if (this.bool_precio_unitario) {
          this.subtotalLocal = (this.precio_unitario_detalle * this.Cantidad).toFixed(2);
        }
      },

      Cantidad: function () {
        this.bool_precio_unitario = true;
        
        if (this.bool_cantidad) {
          this.subtotalLocal = (this.precio_unitario_detalle * this.Cantidad).toFixed(2);
        }
      },
      
    },

    created() {
        this.subtotalLocal = this.subtotal || 0;
    },

    unmounted() {
    this.detalleIngresadoTemporal = [];
  }
};

</script>

<style scoped>
.total {
  padding-right: 20px;
  text-align: right;
}
.agregarDetalleDialog .ds-dialog__body {
  word-break: break-word;
  padding: 0px !important;
}
.agregarDetalleDialog .ds-dialog__footer button {
  text-align: center;
}

.footerActionsRow {
  width: 100%;
}

.footerActions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.rowPrecioCantidad{
    margin-top:25px;
}
.el-radio-group {
    margin-top:8px;
}
.inputCantidad {
    display:flex;
    justify-content:center;
}
.rowDescripcion {
  margin-top: 20px;
}
.colCantidad {
  margin-top:10px;
}
.subtotalContainer {
  display: block;
}
.subtotalContainer .label {
  margin-bottom: 0;
}
.subtotalValue {
  margin-top: 10px;
  text-align: left;
}

@media (max-width: 650px) {
  .el-dialog__title {
    font-size: 16px !important;
  }
  .carro {
    text-align: left;
  }
}

@media (max-width: 360px) {
  .el-dialog__footer button {
    width: 100%;
  }
}
</style>

<style>
.agregarDetalleDialog .ds-dialog__header {
  background-color: var(--main-color);
  color: #ffffff;
  font-size: 1.5em;
  font-weight: bold;
  padding: 10px 0 10px 20px;
}
.agregarDetalleDialog .ds-dialog__body {
  overflow-y: auto;
  padding: 10px 20px;
}

.el-button:focus {
  background: var(--main-color);
  color: white;
}

.paginatorContainer {
  margin-top: 25px;
  text-align: right;
}

@media (max-width: 500px) {
  .agregarDetalleDialog {
    width: 100%;
    max-width: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
  }
  .agregarDetalleDialog .ds-dialog__body {
    overflow-y: auto;
    padding: 10px 20px;
  }
}

.zoomEffect-enter-active {
  animation: zoomAnimation 0.8s;
}

@keyframes zoomAnimation {
  0% {
    transform: scale(4);
    opacity: 0.25;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.label {
  text-align: left;
  font-size: 14px;
  margin-bottom: 4px;
  margin-top: 0px;
}

.el-radio__input.is-disabled.is-checked + span.el-radio__label {
  color: #409eff;
}
</style>